import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { GridOptions } from 'ag-grid-community';
import { GriddataService } from 'src/app/services/griddata.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as mm from 'moment-timezone';
import { ExcelService } from 'src/app/services/excel.service';
import { getCellStyleConfig3 } from 'src/app/constants';

@Component({
  selector: 'app-kanpan-dialog',
  templateUrl: './kanpan-dialog.component.html',
  styleUrls: ['./kanpan-dialog.component.scss'],
})
export class KanbanHistoryDialogComponent implements OnInit {
  rowData: any;
  @ViewChild('osPartsGrid') osPartsGrid;
  columnDefs;
  columnDefsOverage;
  defaultColDef;
  rowSelection;
  kanbanId: string;

  gridOptions;
  paginationPageSize;
  paginationNumberFormatter;
  pagination = true;
  context: any;
  editType;
  suppressClickEdit = true;
  //rightAlligned = 'ag-right-aligned-cell';

  editEnabled: boolean = false;
  freezeStatus: boolean = false;

  adjCodeList: any = [];
  editform: UntypedFormGroup = this.formBuilder.group({
    adjCode: [[], Validators.required],
    adjReason: [''],
  });
  editFormcontrol = this.editform.controls;
  orverageOrShortage;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly gridDataService: GriddataService,
    private readonly spinner: NgxSpinnerService,
    private readonly excelService: ExcelService,
    private readonly dialogRef: MatDialogRef<KanbanHistoryDialogComponent>
  ) {
    this.orverageOrShortage = data.orverageOrShortage;

    this.columnDefs = [
      {
        headerName: 'Dock',
        field: 'dock',
        flex: 0.6,
        floatingFilter: true,
        headerTooltip: 'dock',
      },
      {
        headerName: 'Kanban',
        field: 'kanban',
        width: 100,
        floatingFilter: true,
        //cellClass: this.rightAlligned,
      },

      {
        headerName: 'Part No',
        field: 'part_no',
        width: 120,
        floatingFilter: true,
      },
      {
        headerName: 'Part Description',
        field: 'part_description',
        width: 176,
        floatingFilter: true,
        tooltipField:'part_description'
      },
      {
        headerName: 'QPC',
        headerTooltip: 'Quantity Per Container, Order Lot',
        field: 'qpc',
        sortable: true,
        width: 100,
        floatingFilter: true,
        //cellClass: this.rightAlligned,
      },
      {
        headerName: 'Container',
        field: 'container_renban',
        width: 120,
        floatingFilter: true,
      },
      {
        headerName: 'Module',
        field: 'module_number',
        width: 120,
        floatingFilter: true,
      },


      {
        headerName: 'Tap Qty Boxes',
        field: 'boxes_count',
        sortable: true,
        width: 100,
        floatingFilter: true,
      },
      {
        headerName: 'Tap Qty pieces',
        field: 'tapped_qty',
        headerTooltip: 'Container Code',
        sortable: true,
        width: 80,
        floatingFilter: true,
      },
      {
      headerName: 'Tap DT',
      headerTooltip: 'Tap Date(mm/dd/yyyy hh:mm:ss)',
      field: 'tap_date',
      width: 140,
      floatingFilter: true,
      tooltipField: 'tap_date',
    },

    {
      headerName: 'User',
      field: 'updated_userid',
      width: 150,
      floatingFilter: true,
      resizable: true,
      tooltipField: 'updated_userid',
      // valueGetter: function (params) {
      //   // console.log('params', params);
      //   if (params.data) {
      //     if (params.data?.updated_userid?.startsWith('T_')) {
      //       return params.data.updated_userid.slice(2);
      //     } else {
      //       return params.data.updated_userid;
      //     }
      //   }
      // },
    },

      {
      headerName: 'Updated DT',
      headerTooltip: 'Updated Date(mm/dd/yyyy hh:mm:ss)',
      field: 'updated_datetime',
      width: 140,
      floatingFilter: true,
      tooltipField: 'updated_datetime',
    },

    ];

    this.rowSelection = 'multiple';
    this.editType = 'fullRow';
    this.paginationPageSize = 10;
    this.rowData = data.rowData;
    this.kanbanId =data.kanbanId
    this.gridOptions = this.gridDataService.getGridOptions();
    this.gridOptions.onGridReady = function (params) {
      this.gridApi = params.api;
    };
        this.gridOptions.defaultColDef.cellStyle = getCellStyleConfig3;
    
  }

  enableSave: boolean = false;

  ngOnInit() {
    console.log("this.row",this.rowData)
  }

  exportAsXLSX(): void {
    console.log('hi')
    this.spinner.show();
    // eastern time api
    let easternCurrentDate = String(
      mm().tz('US/Michigan').format('YYYY-MM-DD_HH:mm:ss')
    );
    console.log(easternCurrentDate);
    let data = [];

    // if (this.headerCheckboxChecked) {
      this.osPartsGrid.gridOptions.api.forEachNodeAfterFilter((node) => {
        data.push(node.data);
      });
    //} 
    // if {
    //   data = this.getModifiedRowData();
    // }

    if (data.length < 1) {
      this.spinner.hide();
     
    } 
    else {
      setTimeout(async () => {
        if (this.rowData.length > 0) {
          const exportData: any = [];

          data.forEach((e) => {
            
            const obj:any = {
              dock: e.dock,
              kanban: e.kanban,
              Partno: e.part_no,
              partdesc: e.part_description,
              qpc: e.qpc,
              container: e.container_renban,
              module: e.module_number,
              tap_qty_box: e.boxes_count,
              tap_qty:e.tapped_qty,
              tap_date:e.tap_date,
              stocked:e.stocked,
              modstocked:e.mod_stocked_status,
              user:e.updated_userid,
              updated_datime:e.updated_datetime,
              
              
            };
            exportData.push(obj);
          });
          

          const headers = [
            'DOCK',
            'KANBAN',
            'PART NO',
            'PART DESCRIPTION',
            'QPC',
            'CONTAINER',
            'MODULE',
            'TAP QTY BOXES',
            'TAP QTY',
            'TAP DATE',
            'STOCKED',
            'CONT/MOD STOCKED',
            'USER',
            'UPDATED DATETIME'
         
            
            
          ];

          const timestamp = easternCurrentDate

            .split('.')[0]
            .replace('T', '_')
            .split('')

            .filter((d) => d !== '-' && d !== ':')
            .join('');

          this.excelService.exportAsExcelFile(
            exportData,
          'RobbingHistory'+ this.kanbanId+'_' + timestamp,

            headers
          );
        }
        this.spinner.hide();
      }, 1000);
    }
  }
}
  
   

